export const IS_LOCALHOST = '127.0.0.1' === window.location.hostname;
